<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.crmid"/>
            <div class="basic-title"><em>材料云盘</em></div>
            <div class="qcrb-cloud">
              <div class="noCycle-operation">
                <el-button
                  type="primary"
                  size="small"
                  @click="setCycleChoose(true)"
                >选择</el-button>
                <div
                  class="noCycle-block"
                  v-if="fatherCloudSub.isCycleChoose">
                  <el-button
                    type="primary"
                    size="small"
                    @click="setCycleChoose(false)"
                  >取消</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click="batchDownload">批量下载</el-button>
                  <el-button
                    type="primary"
                    v-if="visible"
                    size="small"
                    @click="studentsArevisible">批量设置学生可见</el-button>
                  <el-checkbox
                    :indeterminate="isindeterminate"
                    v-model="checkisinde"
                    @change="handleCheckAllChange"
                  >全选</el-checkbox>
                </div>
              </div>
            </div>
            <template v-for="(item, index) in fatherCloudData">
              <template v-if="item.title === ''">
                <jm-MaterialCloudPreview
                  :key="index"
                  :additional-data="item.position_list"
                  :additional-sub="fatherCloudSub"
                  @check-list-data="checkListData"
                  :allchecked.sync="checkisinde"
                  :upload-list.sync="uploadList"
                  :primordial-list="primordialList"
                  :origin-data-list.sync="originDataList1"
                  :indeterminate.sync="isindeterminate"
                />
              </template>
              <template v-if="item.title !== ''">
                <el-collapse
                  v-model="activeNames"
                  class="cloud-collapse"
                  :key="index"
                >
                  <el-collapse-item :name='index'>
                    <template slot="title">{{ item.title }}</template>
                    <jm-MaterialCloudPreview
                      :additional-data="item.position_list"
                      :additional-sub="fatherCloudSub"
                      @check-list-data="checkListData"
                      :allchecked.sync="checkisinde"
                      :upload-list.sync="uploadList"
                      :primordial-list="primordialList"
                      :origin-data-list.sync="originDataList1"
                      :indeterminate.sync="isindeterminate"
                    />
                  </el-collapse-item>
                </el-collapse>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import { getBinaryContent } from 'jszip-utils';
import JSZip from 'jszip';
import NProgress from 'nprogress';
import crumbs from '@/components/tool/crumbs';
import jmMaterialCloudPreview from '@/components/tool/materialCloudPreview';

export default {
  data() {
    return {
      activeNames: [0],
      isCycleChoose: false, // 选择
      additionalData: {}, // 临时子组件变量
      checkisinde: false, // 全选
      fatherCloudData: {},
      fatherCloudSub: {
        isCycleChoose: false,
        isCyCLeChooseMask: true,
      },
      checklist: {},
      uploadList: {},
      alluploadList: {}, // 全选时候的状态
      primordialList: [], // 最开始所有的单选框列表与单个做比对全选
      originDataList1: [], // 子组件当前单选数与primordialList做比对length相等时替换
      isindeterminate: false, // 是否显示减号 全选状态
      visible: false,
      offer: '', // 批量学生可见按钮上传
    };
  },
  mounted() {
    this.getDiskInfo();
  },
  methods: {
    /*
    * 初始化数据
    * */
    getDiskInfo() {
      this.$http._post({
        url: '/index/apply_file/getYun',
        data: {
          crm_id: this.$route.params.crmid,
        },
      }).then((res) => {
        this.visible = res.data.teacher;
        this.offer = res.data.offer_id;
        res.data.data.forEach((item) => {
          if (item.title !== '') {
            this.activeNames.push(this.activeNames[this.activeNames.length - 1] + 1);
          }
          item.position_list.forEach((itemA) => {
            itemA.upload_list.forEach((itemB, index) => {
              if (index === 0) {
                this.$set(this.uploadList, itemB.yun_id, []);
                this.$set(this.alluploadList, itemB.yun_id, []);
              }
              this.primordialList.push(`${itemB.yun_id}_${itemB.id}`);
              this.$set(itemB, 'isCycleHoverChoose', true);
              this.$set(itemB, 'isCycleHover', false);
            });
          });
        });
        if (Object.keys(res.data.data_list).length > 0) {
          let YunArr = Object.values(res.data.data_list);
          let IdArr = Object.keys(res.data.data_list);
          YunArr.forEach((item, index) => {
            if (item.length !== 0) {
              item.forEach((itemA) => {
                this.originDataList1.push(`${IdArr[index]}_${itemA}`);
              });
            }
          });
          this.uploadList = res.data.data_list;
        }
        this.fatherCloudData = res.data.data;
        this.fatherCloudData.forEach((item) => {
          item.position_list.forEach((itemA) => {
            itemA.upload_list.forEach((itemB) => {
              this.alluploadList[itemB.yun_id].push(itemB.id);
            });
          });
        });
      });
    },
    /*
     * 全选 checkbox
     * */
    handleCheckAllChange() {
      this.originDataList1 = this.originDataList1.length === 0 ? this.primordialList : [];
      this.indeterminate = false;
      if (this.indeterminate === false) {
        this.uploadList = this.alluploadList;
      }
    },
    /*
     * 选择 取消 控制 显示 || 隐藏
     * */
    setCycleChoose (isTrue) {
      if (isTrue) {
        this.fatherCloudSub.isCycleChoose = isTrue;
        this.fatherCloudSub.isCyCLeChooseMask = false;
      } else {
        this.fatherCloudSub.isCycleChoose = isTrue;
        this.fatherCloudSub.isCyCLeChooseMask = true;
      }
    },
    /*
    * 子组件传输数据
    * */
    checkListData(cb) {
      this.checklist = cb;
    },
    /*
    * 云盘材料下载
    * */
    batchDownload() {
      if (!Object.values(this.uploadList).some(item => item.length > 0)) {
        this.$message.error('请选择下载的项目');
        return false;
      }

      const msg = this.$message({
        message: '下载中...',
        duration: 0,
        showClose: false,
      });
      NProgress.start();

      const files = [];
      let allFiles = [];
      this.fatherCloudData.forEach((item) => {
        item.position_list.forEach((subItem) => {
          subItem.upload_list.forEach((subSubItem) => {
            if (subSubItem.file_list.length > 0) {
              if (this.uploadList[subSubItem.yun_id] && this.uploadList[subSubItem.yun_id].length > 0) {
                this.uploadList[subSubItem.yun_id].forEach((id) => {
                  if (Number(id) === Number(subSubItem.id)) {
                    files.push({ folder: subSubItem.file_name, files: subSubItem.file_list });
                    allFiles = [...allFiles, ...subSubItem.file_list];
                  }
                });
              }
            }
          });
        });
      });

      const getFileName = (folder, file) => {
        const parts = file.split('/');
        const fileName = parts[parts.length - 1];
        return `${folder}/${fileName}`;
      };
      const zip = new JSZip();
      const fileFetching = [];
      const filenames = [];
      let currentProgress = 0;
      files.forEach((item) => {
        zip.folder(item.folder);
        item.files.forEach((file) => {
          filenames.push({ file, folder: item.folder });
          fileFetching.push(getBinaryContent(
            Vue.filter('imgHome')(file, true),
            {
              progress: (p) => {
                if (p.percent === 100) {
                  currentProgress += 100;
                  NProgress.set(currentProgress / 100 / allFiles.length);
                }
              }
            }
          ));
        });
      });

      Promise.all(fileFetching).then((filesData) => {
        filesData.forEach((data, index) => {
          zip.file(getFileName(filenames[index].folder, filenames[index].file), data, { binary: true });
        });
        zip.generateAsync({ type: 'blob' }).then((blob) => {
          this.$http.saveFile(blob, `材料云盘_${this.$route.params.crmid}_${moment().format('YYYYMMDD')}`);
          this.$message.success('下载成功！');
          msg.close();
        });
      }).catch(() => {
        this.$message.error('下载失败！');
        msg.close();
        NProgress.done(true);
      });

      // this.$http._post({
      //   url: '/index/apply_file/downloadFile',
      //   data: { data_list: this.uploadList, crm_id: this.$route.params.crmid }
      // }).then((response) => {
      //   window.location.href = response.data;
      // });
    },
    /*
    * 批量设置学生可见 （需求已去掉 代码保留）
    * */
    studentsArevisible() {
      let list = this.visible === false ? [] : this.uploadList;
      this.$http._post({
        url: '/index/apply_file/setUserView',
        data: { data_list: list, crm_id: this.$route.params.crmid, offer_id: this.offer }
      }).then(() => {
        this.$message.success('保存成功');
      });
    }
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-MaterialCloudPreview': jmMaterialCloudPreview, // 单个盘材料
  }
};
</script>
<style scoped>
  .noCycle-operation{
    margin-left: 10px;
  }
  .noCycle-block{
    margin-left: 10px;
    display: inline-block;
  }
  .noCycle-block .el-checkbox{
    margin-left: 10px;
  }
  .cloud-collapse{
    margin-top: 4px;
  }
</style>
